class ComponentFilterBar extends HTMLElement {
  constructor() {
    super()
    this.toggleButton = this.querySelector('[data-toggle]')
    this.form = this.querySelector('form')
    this.sortContainer = this.querySelector('component-sort')
  }

  connectedCallback() {
    this.form.addEventListener('change', (e) => {
      if (e.target.getAttribute('name') === 'SortOption') {
        this.updateSort(e.target.value)
      }
    })

    document.addEventListener('plp:update', this.updateCount)
    document.addEventListener('plp:loaded', (e) => {
      this.init(e)
    })
  }

  init(e) {
    this.classList.remove('hidden')
    this.classList.add('block')
    this.updateCount(e)
  }

  updateCount(value) {
    const countWrapper = this.querySelector('[data-count]')
    countWrapper.innerHTML = value.detail.productsCount
  }

  updateSort(value) {
    const currentInput = this.sortContainer.querySelector(
      `input[value="${value}"]`
    )
    const toggle = this.sortContainer.querySelector('[data-current-option]')
    if (toggle && currentInput) {
      toggle.innerHTML = currentInput.dataset.label
    }
    const url = new URL(window.location.href)
    url.searchParams.set('sort', value)
    window.history.replaceState(null, null, url.toString())
    document.dispatchEvent(new Event('sort:change'))
    if (this.toggleButton) this.toggleButton.click()
  }
}

customElements.define('component-filter-bar', ComponentFilterBar)
